import { Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/** The authenticated application shell: sidebar + topbar + routed content. */
export function AppLayout() {
  const { user, canViewAmounts, canManageUsers } = useAuth();

  return (
    <div className="flex h-dvh bg-slate-50 text-slate-900">
      <Sidebar role={user?.role} canViewAmounts={canViewAmounts} canManageUsers={canManageUsers} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto custom-scrollbar p-5 lg:p-6">
          <div className="mx-auto max-w-7xl animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
